import React from "react";
import { ShieldCheck, Clock, Users, Handshake } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "Efficiency",
  description: "We optimize digital workflows to eliminate technical friction and maximize operational throughput for modern enterprises.",
  icon: ShieldCheck
}, {
  title: "Oversight",
  description: "Our rigorous technical governance ensures infrastructure integrity and strategic alignment across all organizational levels.",
  icon: Clock
}, {
  title: "Innovation",
  description: "We leverage cutting-edge methodologies to architect resilient solutions for the most complex organizational challenges.",
  icon: Users
}, {
  title: "Integration",
  description: "Seamlessly merging advanced digital frameworks with existing infrastructures to create a unified technical foundation.",
  icon: Handshake
}];
export default function WhyChooseAbj() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="48005" id="our-ethos" ref={ref} className={`dark bg-background text-foreground py-24 px-4 md:px-8 transition-opacity duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight mb-6 text-white font-sans">
            The Century Pointe Ethos
          </h2>
          <p className="text-lg text-muted-foreground font-sans">
            We operate at the nexus of technological precision and organizational foresight, providing the technical oversight necessary for structural excellence.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {features.map((feature, i) => <Card key={i} data-index={i} className="bg-card border-border/50 hover:border-primary/50 transition-colors duration-300 group overflow-hidden relative rounded-xl">
              <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity duration-300 pointer-events-none">
                <feature.icon className="w-32 h-32 text-primary" />
              </div>
              
              <CardHeader className="relative z-10 pb-2">
                <div className="w-14 h-14 rounded-lg bg-primary/10 flex items-center justify-center mb-6 group-hover:bg-primary/20 transition-colors duration-300">
                  <feature.icon className="w-7 h-7 text-primary" />
                </div>
                <CardTitle className="text-2xl font-bold text-white font-sans">
                  {feature.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="relative z-10">
                <CardDescription className="text-base text-muted-foreground leading-relaxed font-sans">
                  {feature.description}
                </CardDescription>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}